import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: ${props => props.theme.padding};
`;

export const Title = styled.h2`
  font-size: ${props => props.theme.underMaintenancePage.fontSizes.title};
`;

export const Text = styled.p`
  font-size: ${props => props.theme.underMaintenancePage.fontSizes.text};
`;



// WEBPACK FOOTER //
// ./containers/UnderMaintenance/UnderMaintenance.style.js